/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

import Provider from './components/Provider';
import connectAdvanced from './components/connectAdvanced';
import connect from './connect/connect';

export { Provider, connectAdvanced, connect };



//////////////////
// WEBPACK FOOTER
// ./~/react-redux/es/index.js
// module id = 507
// module chunks = 60